
import { getTelemetry } from '@cian/telemetry/browser';
import { ITelemetryService } from '../../../../shared/types/telemetryService';

export const TelemetryService = (): ITelemetryService => {
  const mark = (name: string) => {
    try {
      window.performance.mark(name);
    } catch (e) {
      // ignore
    }
  };

  const measure = (name: string, startMark: string, endMark: string): void | PerformanceMeasure => {
    try {
      return window.performance.measure(name, startMark, endMark);
    } catch (e) {
      // ignore
    }
  };

  const increment = (name: string, value?: number | undefined) => {
    const telemetry = getTelemetry();

    telemetry.increment(name, value);
  };

  const timer = (name: string, value: number) => {
    const telemetry = getTelemetry();

    telemetry.timer(name, value);
  };

  const sendMeasuredTimer = (name: string, startMark: string, endMark: string) => {
    // Некоторые браузеры сразу возвращают инстанс PerformanceMeasure
    let entry = measure(name, startMark, endMark);

    // Если инстанс не вернулся сразу, то берем последний инстанс
    if (!entry) {
      try {
        const entries = performance.getEntriesByName(name, 'measure');

        entry = entries[entries.length - 1];
      } catch (e) {
        // ignore
      }
    }

    if (!entry) {
      return;
    }

    timer(name, entry.duration);
  };

  const service = {
    mark,
    measure,
    increment,
    timer,
    sendMeasuredTimer,
  };

  return service;
};
